import React from 'react';
import axios from 'axios';

import { useCms } from '../../../hooks/useCms';
import type { InboxConfigOption } from '../InboxSelectionDialog/InboxSelectionDialog';
import { InboxSelectionDialog } from '../InboxSelectionDialog/InboxSelectionDialog';

interface MoveToFnolInboxDialogProps {
  unclassifiedEmailId: number;
  onClose: () => void;
  onMoved: () => void;
  onMoveWithoutSelection?: () => void;
}

export const MoveToFnolInboxDialog: React.FC<MoveToFnolInboxDialogProps> = ({
  unclassifiedEmailId,
  onClose,
  onMoved,
  onMoveWithoutSelection,
}) => {
  const { user } = useCms();

  const handleSave = async (inbox: InboxConfigOption) => {
    await axios.post(
      `/api/v1/organizations/${user.organization_id}/unclassified_emails/${unclassifiedEmailId}/move_to_fnol_inbox`,
      {
        target_sub_organization_id: inbox.sub_organization_id,
        target_lob: inbox.lob,
      }
    );
    onMoved();
  };

  return (
    <InboxSelectionDialog
      title="Move to FNOL Inbox"
      description="Choose the FNOL inbox to move the email to"
      fetchUrl={`/api/v1/fnol_inbox/inbox/available_inboxes_for_gq_move?unclassified_email_id=${unclassifiedEmailId}`}
      onSave={handleSave}
      onClose={onClose}
      displayOnMove={!!onMoveWithoutSelection}
      onMoveWithoutSelection={onMoveWithoutSelection}
    />
  );
};
